import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { AutomationAction } from "../_types/automation-action";
@Injectable({
    providedIn: 'root',
})

export class AutomationsActionsService extends Service<AutomationAction> {
  public override type = 'automationsActions';
  public override url = 'common/automationActions';
}
